<tui-root *transloco="let t">
  @if (!isBrowserIE) {
    <router-outlet data-testid="content" />
    @if (isLoading$ | async) {
      <pxc-loader class="fixed inset-0 z-50" data-testid="global-loader" [fullscreen]="true" [useLogo]="true" />
    }
    <ng-container ngProjectAs="tuiOverContent">
      <pxc-drawer-portal />
    </ng-container>
  } @else {
    <div class="flex h-screen items-center justify-center">
      <div class="flex flex-col items-center">
        <img class="max-h-24" src="https://cdn.pixacare.com/logo/top-transparent.svg" />
        <h1>{{ t('Navigateur Incompatible') }}</h1>
        <p>
          {{
            t("Vous utilisez Internet Explorer qui n'est pas compatible avec les standards de sécurité de Pixacare.")
          }}
        </p>
        <p>{{ t('Merci de vous connecter avec un autre navigateur (Edge, Chrome, Firefox, Safari, Opéra).') }}</p>
      </div>
    </div>
  }
</tui-root>
